module.exports = __webpack_public_path__ + "static/go-burguer-jogo-basquete-bg-01602a33cb3e8c79684d0da6d436121c.jpg";